import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceListController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceListController.php
* @route '/api/marketplace/module'
*/
const GetMarketplaceListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMarketplaceListController.url(options),
    method: 'get',
})

GetMarketplaceListController.definition = {
    methods: ["get","head"],
    url: '/api/marketplace/module',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceListController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceListController.php
* @route '/api/marketplace/module'
*/
GetMarketplaceListController.url = (options?: RouteQueryOptions) => {
    return GetMarketplaceListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceListController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceListController.php
* @route '/api/marketplace/module'
*/
GetMarketplaceListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetMarketplaceListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Marketplace\GetMarketplaceListController::__invoke
* @see app/Http/Controllers/Marketplace/GetMarketplaceListController.php
* @route '/api/marketplace/module'
*/
GetMarketplaceListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetMarketplaceListController.url(options),
    method: 'head',
})

export default GetMarketplaceListController